var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "Modal",
    attrs: {
      "id": "migration-done-modal"
    }
  }, [_c('div', {
    staticClass: "Modal__background"
  }), _c('div', {
    staticClass: "Modal__container whole",
    class: {
      show: _vm.isShow
    }
  }, [_c('div', {
    staticClass: "Modal__content"
  }, [_vm._m(0), _c('h2', {
    domProps: {
      "innerHTML": _vm._s(_vm.tt('랩매니저 PRO<br>전환 완료'))
    }
  }), _vm._m(1), _vm._l(_vm.data.institute, function (institute) {
    return _c('div', [_c('ul', {
      staticClass: "prev-account"
    }, [_c('li', [_vm._v("기관명: " + _vm._s(institute.name))]), _c('li', [_vm._v("연구실: " + _vm._s(institute.groupNames))]), _c('li', [_vm._v("요청인: " + _vm._s(institute.userName))]), _c('li', [_vm._v(" 요청 일시: " + _vm._s(_vm.dateTimeFormat(institute.startDatetime)) + " ")])]), _c('ul', {
      staticClass: "license-noti"
    }, [_c('li', [_vm._v(" 라이선스: " + _vm._s(institute.license.name) + "(활성화 : " + _vm._s(_vm.dateFormat(institute.startDatetime)) + "까지) ")])])]);
  }), _c('div', {
    staticClass: "btn-wrap"
  }, [_c('button', {
    staticClass: "Btn__complete",
    on: {
      "click": function ($event) {
        return _vm.hide();
      }
    }
  }, [_vm._v(" 랩매니저 PRO 시작하기 ")]), _c('button', {
    staticClass: "guide",
    on: {
      "click": _vm.openLmGuide
    }
  }, [_vm._v(" 랩매니저 가이드보기 ")])])], 2)])]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "imgbox"
  }, [_c('img', {
    attrs: {
      "src": require("@/assets/images/migration-done.png")
    }
  })]);
},function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('p', [_vm._v(" 고객요청에 의하여, 기존 계정의 연구실이"), _c('br'), _vm._v("아래와 같이 랩매니저 PRO로 전환되었습니다."), _c('br'), _vm._v("랩매니저 PRO의 새로운 기능을 지금 경험하세요. ")]);
}]

export { render, staticRenderFns }